import { render, staticRenderFns } from "./NavbarCourseIcon.vue?vue&type=template&id=2e26e9c3&"
import script from "./NavbarCourseIcon.vue?vue&type=script&lang=ts&"
export * from "./NavbarCourseIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2e26e9c3', component.options)
    } else {
      api.reload('2e26e9c3', component.options)
    }
    module.hot.accept("./NavbarCourseIcon.vue?vue&type=template&id=2e26e9c3&", function () {
      api.rerender('2e26e9c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/NavbarCourseIcon.vue"
export default component.exports